export default __webpack_public_path__ + "static/media/miguel-lopes-46.e7c246b3.jpg";